function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function PinnedNoteIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M14.0807 2.7478L21.1518 9.81887L19.7376 11.2331L18.3234 9.81886L15.5094 12.6617L14.0808 11.2331L16.8953 8.39075L15.495 6.99043L12.6665 9.81886L11.2384 8.39075L14.0669 5.56232L12.6665 4.16202L14.0807 2.7478Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M12.7541 11.3203L15.6213 14.1954C16.6633 15.3723 16.6212 17.1779 15.4952 18.304L5.59567 8.40451C6.76543 7.23475 8.66854 7.23475 9.83831 8.40451L12.7541 11.3203Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M10.5453 14.7684L9.13105 13.3542L3.4742 19.0111L2.76709 21.1324L4.88841 20.4253L10.5453 14.7684Z",
    fill: "currentColor"
  }));
}
export function PinnedNoteIconSmall(props) {
  return ___EmotionJSX(PinnedNoteIcon, _extends({
    size: "small"
  }, props));
}